import type { GetContentQueryParams, IdFieldName } from '../types';
import { ClientApiType } from '../types';

const CONTENT_TYPE = {
    HEADER: 'header',
    FOOTER: 'footer',
    DRAWER: 'drawer',
};

const entries = {
    ARTICLE_PAGE: {
        id: '',
        contentType: 'articlePage',
    },
    PLP: {
        id: 'test',
        contentType: 'plpPage',
    },
    PDP: {
        id: 'default',
        contentType: 'pdpPage',
    },
    HOME: {
        id: 'home',
        contentType: 'homepage',
    },
    CONTENT_PAGE: {
        id: 'default',
        contentType: 'contentPage',
    },
    FAQ: {
        id: 'faq',
        contentType: 'faq',
    },
    CART: {
        id: 'default',
        contentType: 'cartPage',
    },
    HEADER: {
        id: 'header-test',
        contentType: CONTENT_TYPE.HEADER,
    },
    LEGACY_HEADER: {
        id: 'legacy-header-test',
        contentType: CONTENT_TYPE.HEADER,
    },
    FOOTER: {
        id: 'footer',
        contentType: CONTENT_TYPE.FOOTER,
    },
    LEGACY_FOOTER: {
        id: 'legacy-footer',
        contentType: CONTENT_TYPE.FOOTER,
    },
    CURBSIDE_INFO: {
        id: 'curbside-info',
        contentType: CONTENT_TYPE.DRAWER,
    },
    CURBSIDE_PICKUP_DRAWER: {
        id: 'curbside-pickup-drawer',
        contentType: 'curbsidePickupDrawer',
    },
    AUTOSHIP_INFO: {
        id: 'autoship-drawer',
        contentType: CONTENT_TYPE.DRAWER,
    },
    CHARITY_DRAWER: {
        id: 'charitiesDonationDrawer',
        contentType: CONTENT_TYPE.DRAWER,
    },
    HELP_ARTICLE: {
        id: 'default',
        contentType: 'helpArticle',
    },
    LEARNING_CENTER_ARTICLE: {
        id: 'default',
        contentType: 'learningCenterArticle',
    },
    VISUAL_NAV: {
        id: '',
        contentType: 'visualNavigation',
    },
    SEO_BLOCK: {
        id: '',
        contentType: 'seoBlock',
    },
    TREATS_REWARDS_GUEST: {
        id: 'page-home-web-guest',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    TREATS_REWARDS_MENU: {
        id: 'menu-web-signed-in',
        contentType: 'treatsMenu',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    TREATS_REWARDS_HOME: {
        id: 'page-home-web-signed-in-v2',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    TREATS_REWARDS_OFFERS: {
        id: 'page-offers-web-signed-in-v2',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    TREATS_REWARDS_HOW_IT_WORKS: {
        id: 'page-how-it-works-web-signed-in-v2',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    TREATS_REWARDS_POINTS_HISTORY: {
        id: 'page-points-history-web-signed-in-v2',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    TREATS_REWARDS_SIGNED_IN_ALL: {
        id: 'list-pages-treats-signed-in',
        contentType: 'list',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    SIGN_IN: {
        id: 'page-account-sign-in',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
    INTERSTITIAL_SIGN_IN: {
        id: 'checkout/sign-in',
        contentType: 'accountSignIn',
    },
    ACCOUNT_ABOUT_YOU: {
        id: 'page-account-about-you',
        contentType: 'page',
        clientApiType: ClientApiType.LOYALTY,
        idFieldName: 'identifier' as IdFieldName,
    },
};

export const CONTENTFUL_ENTRIES: Record<keyof typeof entries, GetContentQueryParams> = entries;
